module.exports = __webpack_public_path__ + "img/thorlabs.6e8d6533.png";